import { combineReducers } from 'redux';

import marketToMarket from './marketToMarket.reducer';

const reducer = combineReducers({ marketToMarket });

export default reducer;
